import { createContext } from "react";

export type AuthStatus = "loading" | "anonymous" | "authenticated" | "forbidden" | "unavailable";

export type AuthContextValue = {
  status: AuthStatus;
  tokenReady: boolean;
  userName: string;
  login: (redirectPath?: string) => void;
  logout: () => void;
  getToken: (forceRefresh?: boolean) => Promise<string>;
};

export const AuthContext = createContext<AuthContextValue>({
  status: "loading",
  tokenReady: false,
  userName: "",
  login: () => undefined,
  logout: () => undefined,
  getToken: async () => {
    throw new Error("auth provider is not ready");
  }
});
